import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { orderBy, sortBy, flatMapDeep } from "lodash";
import { v4 as uuid } from "uuid";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export function getDefaultContentTypes(images) {
  return [
    {
      type: "title",
      title: "Titel & Untertitel",
      additionalName: "",
      id: uuid()
    },
    { type: "date", title: "Datum", additionalName: "", id: uuid() },
    {
      type: "images1",
      title: "Bilder",
      additionalName: "",
      selectedImages: Object.assign([], images),
      orderedImages: Object.assign([], images),
      id: uuid()
    },
    {
      type: "text1",
      title: "Textblock",
      additionalName: "Textblock 1",
      id: uuid()
    },
    { type: "video", title: "Video", additionalName: "", id: uuid() },
    {
      type: "text2",
      title: "Textblock",
      additionalName: "Textblock 2",
      id: uuid()
    },
    {
      type: "images2",
      title: "Bilder",
      additionalName: "",
      selectedImages: [],
      orderedImages: Object.assign([], images),
      id: uuid()
    },
    {
      type: "text3",
      title: "Textblock",
      additionalName: "Textblock 3",
      id: uuid()
    },
    { type: "files", title: "Dateien", additionalName: "", id: uuid() }
  ];
}

export async function loadConfig() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal
  };
  try {
    const response = await axios.get(env.news_api_client_url + "config/", {
      headers,
      params
    });
    this.config = response.data;
  } catch (error) {
    this.createError(error);
  }
}

export async function loadIssues() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal
  };
  try {
    const response = await axios.get(env.news_api_client_url + "issue/", {
      headers,
      params
    });
    this.issues = orderBy(response.data, ["release_date"], ["desc"]);
    this.issues = this.issues.map(item => {
      const deadlineDate = new Date(item.deadline_date);
      const currentTime = new Date();
      item.closed = deadlineDate < currentTime || item.status === "closed";
      return item;
    });
  } catch (error) {
    this.createError(error);
  }
}

export function getIssueById(id) {
  const currentTime = new Date();
  const match = Array.isArray(this.issues)
    ? this.issues.filter(data => data._id === id)
    : [];
  // refresh closed status
  match.map(item => {
    const deadlineDate = new Date(item.deadline_date);
    item.closed = deadlineDate < currentTime || item.status === "closed";
  });

  return match[0] || false;
}

export async function loadFeatures() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal
  };
  try {
    const response = await axios.get(env.news_api_client_url + "feature/", {
      headers,
      params
    });
    this.features = response.data;
  } catch (error) {
    this.createError(error);
  }
}

export async function loadAppContentTypes() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal
  };
  try {
    const response = await axios.get(
      env.news_api_client_url + "app_content_type/",
      {
        headers,
        params
      }
    );
    this.appContentTypes = response.data;
  } catch (error) {
    this.createError(error);
  }
}

export function getFeatureById(id) {
  const match = this.features.filter(data => data._id === id);
  return match[0] || false;
}

export function getCategoryForPrintNews(news, allCategories = false) {
  const printFeatureGroups = sortBy(
    this.featureGroups.filter(data => data.channels.includes("gemeindeblatt")),
    "sort"
  );
  if (printFeatureGroups.length === 0) {
    this.createError({
      text: "keine Rubriken-Merkmalsgruppe angelegt! Nachricht:" + news.title
    });
    return [];
  }

  const printNewsFeatures = printFeatureGroups.map(
    printFeatureGroups => printFeatureGroups.features
  );
  let features = flatMapDeep(printNewsFeatures);

  features = features.filter(data => news.feature_ids.includes(data._id));

  if (!allCategories) return features[0];
  else return features;
}

export function getCategoryForPrintNewsTitle(news) {
  const feature = this.getCategoryForPrintNews(news);
  if (!feature) {
    return "keine Rubrik";
  }
  return feature.title;
}

export function getFeatureTitles(news, separator = ", ") {
  const features = this.features.filter(feature =>
    news.feature_ids.includes(feature._id)
  );
  return features.map(feature => feature.title).join(separator);
}

export function getFeatureGroupTitles(news, separator = ", ") {
  const features = news.feature_ids.map(id =>
    this.features.find(_ => _._id === id)
  );
  features.sort((a, b) => a.sort - b.sort);
  const featureGroups = features.map(feature =>
    this.featureGroups.find(_ => _._id === feature?.feature_group_id)
  );
  const featureGroupTitles = featureGroups
    .filter(featureGroup => featureGroup?.title?.length)
    .map(featureGroup => featureGroup.title);
  return featureGroupTitles.join(separator);
}

export async function loadFeatureGroups() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal
  };
  try {
    const response = await axios.get(
      env.news_api_client_url + "feature_group/",
      {
        headers,
        params
      }
    );
    this.featureGroups = response.data;
  } catch (error) {
    this.createError(error);
  }
}

export function getFeatureGroupById(id) {
  const match = this.featureGroups.filter(data => data._id === id);
  return match[0] || false;
}

export function isLocked(news) {
  return this.getIssueById(news.issue_id)?.closed;
}

export function isDeleteable(news) {
  const hasWebChannel = news.channels.includes("web");
  if (hasWebChannel) {
    return true;
  }
  return !news.released || !this.getIssueById(news.issue_id)?.closed;
}

export async function createError(error) {
  this.$store.dispatch("createError", error);
}

export async function createSuccess(successMessage) {
  this.$store.dispatch("createSuccess", successMessage);
}

export function getListHTML(apiKey) {
  const innerHTML = `<div class="eonews-widget" id="eonews-list-widget"
     data-api-url="${env.news_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-target-uri="/detail/#xxxSLUGxxx"
     data-list-uri="/"
     data-teaser-uri="/teaser/"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-secondary="${apiKey.color["color-secondary"]}"
     data-color-accent="${apiKey.color["color-accent"]}"
     data-color-error="${apiKey.color["color-error"]}"
     data-color-info="${apiKey.color["color-info"]}"
     data-color-warning="${apiKey.color["color-warning"]}"
 ></div>

<div class="eonews-async-scripts" data-path="${env.news_widget_api_url}">
    <div data-name="eonews-list"></div>
</div>
<script type="module" src="${env.news_widget_api_url}loadAsyncNews.min.js"></script>
<link href="${env.news_widget_api_url}eonews-Variables.css" rel="stylesheet" type="text/css">`;

  return innerHTML;
}

export function getTeaserHTML(apiKey) {
  const innerHTML = `<div class="eonews-widget" id="eonews-teaser-widget"
     data-api-url="${env.news_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-target-uri="/detail/#xxxSLUGxxx"
     data-list-uri="/list/"
     data-teaser-uri=""
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-secondary="${apiKey.color["color-secondary"]}"
     data-color-accent="${apiKey.color["color-accent"]}"
     data-color-error="${apiKey.color["color-error"]}"
     data-color-info="${apiKey.color["color-info"]}"
     data-color-warning="${apiKey.color["color-warning"]}"
></div>

<div class="eonews-async-scripts" data-path="${env.news_widget_api_url}">
    <div data-name="eonews-teaser"></div>
</div>
<script type="module" src="${env.news_widget_api_url}loadAsyncNews.min.js"></script>
<link href="${env.news_widget_api_url}eonews-Variables.css" rel="stylesheet" type="text/css">`;

  return innerHTML;
}

export function getSingleTeaserHTML(apiKey) {
  const innerHTML = `<div class="eonews-widget" id="eonews-single-teaser-widget"
     data-api-url="${env.news_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-target-uri="/detail/#xxxSLUGxxx"
     data-list-uri="/list/"
     data-teaser-uri=""
     data-single-teaser-uri="/single-teaser/"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-secondary="${apiKey.color["color-secondary"]}"
     data-color-accent="${apiKey.color["color-accent"]}"
     data-color-error="${apiKey.color["color-error"]}"
     data-color-info="${apiKey.color["color-info"]}"
     data-color-warning="${apiKey.color["color-warning"]}"
></div>

<div class="eonews-async-scripts" data-path="${env.news_widget_api_url}">
    <div data-name="eonews-singleTeaser"></div>
</div>
<script type="module" src="${env.news_widget_api_url}loadAsyncNews.min.js"></script>
<link href="${env.news_widget_api_url}eonews-Variables.css" rel="stylesheet" type="text/css">`;

  return innerHTML;
}

export function getDetailHTML(apiKey) {
  const innerHTML = `<div class="eonews-widget" id="eonews-dv-widget"
     data-api-url="${env.news_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-list-uri="/list/"
     data-target-uri=""
     data-teaser-uri=""
     data-news="meine-nachricht"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-secondary="${apiKey.color["color-secondary"]}"
     data-color-accent="${apiKey.color["color-accent"]}"
     data-color-error="${apiKey.color["color-error"]}"
     data-color-info="${apiKey.color["color-info"]}"
     data-color-warning="${apiKey.color["color-warning"]}"
></div>

<div class="eonews-async-scripts" data-path="${env.news_widget_api_url}">
    <div data-name="eonews-detailView"></div>
</div>
<script type="module" src="${env.news_widget_api_url}loadAsyncNews.min.js"></script>
<link href="${env.news_widget_api_url}eonews-Variables.css" rel="stylesheet" type="text/css">`;

  return innerHTML;
}

export function getNewsIssuesListHTML(apiKey) {
  const innerHTML = `<div class="eonews-issues-widget" id="eonews-issues-list-widget"
     data-api-url="${env.news_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-show-release-year="${Number(apiKey.newsIssuesWidget.showReleaseYear)}"
     data-show-release-month="${Number(
       apiKey.newsIssuesWidget.showReleaseMonth
     )}"
     data-color-button="${apiKey.newsIssuesWidget.color["color-button"]}"
     data-color-background="${
       apiKey.newsIssuesWidget.color["color-background"]
     }"
     data-color-text="${apiKey.newsIssuesWidget.color["color-text"]}"
     data-color-icon="${apiKey.newsIssuesWidget.color["color-icon"]}"
></div>

<div class="eonews-issues-async-scripts" data-path="${
    env.news_issues_widget_api_url
  }">
    <div data-name="eonews-issues-list"></div>
</div>
<script type="module" src="${
    env.news_issues_widget_api_url
  }loadAsyncNewsIssues.min.js"></script>
<link href="${
    env.news_issues_widget_api_url
  }eonews-issues-Variables.css" rel="stylesheet" type="text/css">`;

  return innerHTML;
}

export const imports = [
  {
    typeId: "Allgäuer-Zeitung-ID",
    isActive: principal => {
      const login = principal.additional_data?.allgaeuerZeitungLogin;
      return login?.some(_ => _.feedUrl?.length);
    }
  }
];
